import useLogger from "./useLogger";
import usePortalType from "./usePortalType";

const useTrackIllustraion = () => {
  const logger = useLogger();
  const portalType = usePortalType();

  return (user) => {
    logger.trackEvent("Illustration", {
      portal: portalType ?? "",
      provider: user?.provider,
      roleName: user?.role?.roleName ?? "",
      userName: user?.userName ?? "",
    });
  };
};

export default useTrackIllustraion;
